import React, { useEffect, useRef } from "react";
import "../../Style/Theme/index.css";
import lottie from "lottie-web";
const MandateSuccessAnimation = () => {
  const container = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: require("../../utils/lottie/mandateSuccess.json"),
    });
  }, []);
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div
        className="lottieContainer animationFilter"
        ref={container}
        style={{
          width: "200px",
          height: "200px",
          position: "relative",
        }}
      ></div>
    </div>
  );
};

export default MandateSuccessAnimation;
